import React from 'react';
import {Link} from 'react-router-dom';
import {ArticleCategory} from 'api';

class NewsCategoryMenu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      order: 'id DESC',
      toggeled: false
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        order: this.state.order
      }
    };
    ArticleCategory.actions.list.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    return (
      <div className="news-category-menu">
        <h2 className='news-category-menu-title'>Danh mục</h2>
        <div className='news-category-menu-wrap-list'>
          {
            this.state.data.map((item, i) => {
              // ignore cms category
              if (item.id !== '5a031f41f75c7330ed575bfd') {
                return (
                  <div className='news-category-menu-item'>
                    <Link className='item-link' key={i} to={`/news-category/${item.id}`}>{item.name}</Link>
                  </div>
                );
              }
            })
          }
        </div>
      </div>
    );
  }
}

export default NewsCategoryMenu;



// WEBPACK FOOTER //
// ./components/news/NewsCategoryMenu.jsx